<mat-card>
    <mat-card-content>
        <form [formGroup]="priceForm" (ngSubmit)="onSubmit()">
            <div class="fons-gris">
                <h2>Vehículo</h2>
                <mat-form-field>
                    <mat-label>Tipo vehículo</mat-label>
                    <mat-select formControlName="vehicleType" required>
                        <mat-option value="1">
                            Coche
                        </mat-option>
                        <mat-option value="3">
                            Moto
                        </mat-option>
                        <mat-option value="1">
                            Camper y furgonetas
                        </mat-option>
                        <mat-option value="444">
                            Autocaravana
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Marca</mat-label>
                    <input type="text" matInput formControlName="brandName" [matAutocomplete]="autoBrand"
                        (input)="filterBrands($event)" required />
                    <mat-autocomplete #autoBrand="matAutocomplete" (optionSelected)="onBrandSelected($event)">
                        @for (brand of filteredBrands; track brand.codigo) {
                        <mat-option [value]="brand.nombre">
                            {{ brand.nombre }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <mat-error
                    *ngIf="priceForm.controls['brandName'].hasError('forbiddenBrand') && priceForm.controls['brandName'].touched">
                    Lo sentimos pero no se puede asegurar vehículos de la marca {{ priceForm.controls['brandName'].value
                    }} por dias.
                </mat-error>
                <mat-error
                    *ngIf="priceForm.controls['brandName'].hasError('noOptionSelected') && priceForm.controls['brandName'].touched">
                    Selecciona una marca del listado.
                </mat-error>
                <mat-form-field>
                    <mat-label>Modelo</mat-label>
                    <input type="text" matInput formControlName="modelName" [matAutocomplete]="autoModel"
                        (input)="filterModels($event)" required />
                    <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="onModelSelected($event)">
                        @for (model of filteredModels; track model.codigo) {
                        <mat-option [value]="model.nombre">
                            {{ model.nombre }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <mat-error
                    *ngIf="priceForm.controls['modelName'].hasError('noOptionSelected') && priceForm.controls['modelName'].touched">
                    Selecciona un modelo del listado.
                </mat-error>
                <mat-form-field>
                    <mat-label>Versions</mat-label>
                    <input type="text" matInput formControlName="versionName" [matAutocomplete]="autoVersion"
                        (input)="filterVersions($event)" required />
                    <mat-autocomplete #autoVersion="matAutocomplete" (optionSelected)="onVersionSelected($event)">
                        @for (version of filteredVersions; track version.codigo) {
                        <mat-option [value]="version.nombre">
                            {{ version.nombre }}
                        </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <mat-error
                    *ngIf="priceForm.controls['versionName'].hasError('noOptionSelected') && priceForm.controls['versionName'].touched">
                    Selecciona una versión del listado.
                </mat-error>
                <mat-form-field>
                    <mat-label>Matrícula</mat-label>
                    <input matInput type="text" formControlName="licensePlate" required />

                </mat-form-field>
                <mat-error
                    *ngIf="priceForm.controls['licensePlate'].hasError('spanishPlate') && priceForm.controls['licensePlate'].touched">
                    Introduce una matrícula española válida (ex: "1234 BCD" o "B-1234-AB").
                </mat-error>

            </div>
            <p>*solo vehículos inferiores a 3.500 kg</p>
            <div class="fons-gris">
                <h2>Tomador del seguro</h2>
                <mat-form-field appearance="outline">
                    <mat-label>Fecha de nacimiento</mat-label>
                    <input matInput [matDatepicker]="pickerBirthday" formControlName="birthday">
                    <mat-datepicker-toggle matSuffix [for]="pickerBirthday"></mat-datepicker-toggle>
                    <mat-datepicker #pickerBirthday></mat-datepicker>
                </mat-form-field>
                <mat-error
                    *ngIf="priceForm.get('birthday')?.hasError('edatMinima') && priceForm.get('birthday')?.touched">
                    La edad mínima es {{ priceForm.get('birthday')?.getError('edatMinima')?.requiredAge }} años.
                    <br /><br />
                </mat-error>
                <mat-error
                    *ngIf="priceForm.get('birthday')?.hasError('matDatepickerParse') && priceForm.get('birthday')?.touched">
                    Fecha inválida. Usa el formato Dia/Mes/Año.
                </mat-error>
                <mat-form-field>
                    <mat-label>Código Postal</mat-label>
                    <input matInput type="text" formControlName="postalCode" required />
                </mat-form-field>
                <mat-error
                    *ngIf="priceForm.get('postalCode')?.hasError('required') && priceForm.get('postalCode')?.touched">
                    El código postal es obligatorio.
                </mat-error>

                <!-- Error: format invàlid (no 5 dígits) -->
                <mat-error
                    *ngIf="priceForm.get('postalCode')?.hasError('postalInvalid') && priceForm.get('postalCode')?.touched">
                    {{ priceForm.get('postalCode')?.getError('postalInvalid') }}
                </mat-error>

                <!-- Error: Ceuta/Melilla -->
                <mat-error
                    *ngIf="priceForm.get('postalCode')?.hasError('exclouCeutaMelilla') && priceForm.get('postalCode')?.touched">
                    Código postal inválido, sólo es posible asegurar en España peninsular, Baleares o Canarias.
                </mat-error>
            </div>
            <div class="fons-transparent">
                <button mat-button type="submit" mat-raised-button color="primary" [disabled]="!priceForm.valid"
                    class="full-width-button">
                    Seguir
                </button>
            </div>

        </form>
    </mat-card-content>
</mat-card>